import { Outlet } from "react-router-dom";
import FlightAssistant from "../common/FlightAssistant";
import FloatingBackdrop from "../common/FloatingBackdrop";
import Navbar from "./Navbar";
import Footer from "./Footer";

function MainLayout() {
  return (
    <div className="relative min-h-screen bg-soft-white text-slate-text">
      <FloatingBackdrop />
      <FlightAssistant />
      <Navbar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
    </div>
  );
}

export default MainLayout;
